import * as z from "zod/v4";

export const getMobileMessageInfraStatus = {
  name: "getMobileMessageInfraStatus" as const,
  input: z.object({}),
  output: z.object({
    devices: z.array(
      z.object({
        deviceId: z.string(),
        phoneNumber: z.string(),
        udid: z.string().nullable(),
        status: z.string(),
        name: z.string().nullable(),
        version: z.string().nullable(),
        lastHeartbeatAt: z.string().nullable(),
      }),
    ),
    queues: z.object({
      outboundCommands: z.number(),
      inboundMessages: z.number(),
      outboundResults: z.number(),
      heartbeat: z.number(),
    }),
    stats: z.object({
      totalConversations: z.number(),
      totalFlows: z.number(),
      activeFlows: z.number(),
    }),
  }),
};
